import { render, staticRenderFns } from "./QuoteRemarks.vue?vue&type=template&id=ad1e9cf4&scoped=true"
import script from "./QuoteRemarks.vue?vue&type=script&lang=js"
export * from "./QuoteRemarks.vue?vue&type=script&lang=js"
import style0 from "./QuoteRemarks.vue?vue&type=style&index=0&id=ad1e9cf4&prod&lang=scss&scoped=true"
import style1 from "./QuoteRemarks.vue?vue&type=style&index=1&id=ad1e9cf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1e9cf4",
  null
  
)

export default component.exports